module.exports = __webpack_public_path__ + "img/album_art_android.bc1ffa9c.png";